/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "下載Bumble",
      "接受全部",
      "管理選項",
      "Cookie政策",
      "返回",
      "電話號碼不正確",
      "(c) {{current_year}} Bumble | 保留所有版權",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "關於",
      "大使",
      "嗡嗡",
      "我們使用cookies。保留當前設定表示您同意這一點。",
      "下載應用",
      "Android下載",
      "iOS下載",
      "對不起，無法找到該網頁。",
      "登入",
      "加入",
      "一起加入吧！",
      "糟糕，出錯啦"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小時"
            ],
            "singular": [
                  "小時"
            ]
      },
      "minute": {
            "plural": [
                  "分鐘"
            ],
            "singular": [
                  "分鐘"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
